import { FormControl, FormGroup, AbstractControl, ValidatorFn } from '@angular/forms';

export let customValidators = {

    conditionalValidator(refControl: AbstractControl, validation: ValidatorFn, refValue: any = 1): ValidatorFn {
        return (control: FormControl): { [key: string]: any } => {
            if (refControl.value === refValue) {
                return validation(control);
            }
            return null;
        };
    },

    validateExpirationDate(c: any) {
        if (c.value && isValidDate(c.value)) {
            let dateBirthday: any = new Date(c.parent.parent.controls.birthdayDate.value);
            dateBirthday = dateBirthday.getTime();
            const dateIssued = convertDate(c.parent.controls.identificationDocumentIssuedDate.value)
                .getTime();
            const dateInput = convertDate(c.value)
                .getTime();
            if (dateInput < dateBirthday) {
                return { validDateToBirthday: true };
            } else {
                if (isValidDate(c.parent.controls.identificationDocumentIssuedDate.value)) {
                    if (dateIssued > dateInput) {
                        return { invalidDate: true };
                    } else {
                        return null;
                    }
                }
            }
            return null;
        }
    },

    validateIssuedDate(c: any) {
        if (c.value && isValidDate(c.value)) {
            const dateInput = convertDate(c.value)
                .getTime();
            const dateExpiration = convertDate(c.parent.controls.identificationDocumentExpirationDate.value)
                .getTime();
            if (isValidDate(c.parent.controls.identificationDocumentExpirationDate.value)) {
                if (dateInput > dateExpiration) {
                    return { invalidDate: true };
                } else {
                    return null;
                }
            }
            return null;
        }
    },

    /**
     * Validar CPF e CNPJ
     * @param c Form Control
     */
    validCPF(c: FormControl) {
        if (c.value) {
            const cleanDoc = c.value.replace(/[_\W]+/g, '');
            if (cleanDoc.length <= 11) {
                const value = c.value;
                if (VerificaCPF(c.value || '')) {
                    return null;
                } else if (c.value) {
                    return { validCPF: true };
                } else {
                    return { validCPF: false };
                }
            } else if (cleanDoc.length > 11) {
                const cnpj = c.value;
                if (validateCnpj(cnpj)) {
                    return null;
                } else {
                    return { validCNPJ: true };
                }
            }
        }
    },

    validOnlyCPF(c: FormControl) {
        if (c.value) {
            const cleanDoc = c.value.replace(/[_\W]+/g, '');
            const value = c.value;
            if (VerificaCPF(c.value || '')) {
                return null;
            } else if (c.value) {
                return { validCPF: true };
            } else {
                return { validCPF: false };
            }
        }
    },

    /** Valida se um form control possui um valor válido para um nome completo */
    fullName(c: FormControl) {
        if (c.value == "")
            return null;

        if (c.value) {
            const slices = c.value.split(' ');
            return slices.filter((res) => res).length >= 2 ? null : { fullName: false };
        }
        return { fullName: false };
    },

    fullNameWithoutSpecialCharacter(c: FormControl) {
        if (c.value) {
            const slices = c.value.split(' ');
            return slices.filter((res) => res).length >= 2 ? null : { customSpecialCharacterValidation: false };
        }
        return { customSpecialCharacterValidation: false };
    },
    validOnlyCnpj(c: FormControl) {

        if (!!c.value && validateCnpj(c.value)) {
            return null;
        }
        return { validCNPJ: false };
    },

    validCNH(formControl: FormControl) {
        if (/\b[(0-9)]{11}\b/.test(formControl.value)) {
            return null;
        }

        return { validCNH: true };
    },

    validateMaxCurrencyNumber(c: FormControl) {
        // tslint:disable-next-line: prefer-const
        let valueForm = c.value ? c.value : 0;
        if (valueForm.toString().length > 13 || valueForm <= 0) {
            return { validateMaxCurrencyNumber: true };
        }
        return null;
    },

    atLeaseOne(c: FormControl) {
        if (c.value.length && (typeof c.value === 'object')) {
            const totalAnswer = c.value.reduce((count, item) => {
                return count + item.answerID;
            }, 0);
            if (totalAnswer === 0) return { atLeaseOne: true };
        }
    },

    validateNegativeValue(c: FormControl) {
        // tslint:disable-next-line: prefer-const
        let valueForm = c.value ? c.value : 0;
        if (valueForm < 0) {
            return { validateNegativeValue: true };
        }
        return null;
    },

    minvalue(c: FormControl) {
        if (c.value) {
            let value = c.value.replace(/[^0-9]+/ig, '');
            value = Number(value / 100);
            if (value >= 100) {
                return null;
            } else {
                return { minvalue: true };
            }
        } else {
            return { minvalue: true };
        }
    },

    minInvestimentValueZeroPrecision(c: FormControl) {
        if (c.value) {
            let value = c.value.replace(/[^0-9]+/ig, '');
            value = Number(value);
            if (value >= 100) {
                return null;
            } else {
                return { minvalue: true };
            }
        } else {
            return { minvalue: true };
        }
    },

    /**
     * Verifica se uma data no formato dd/MM/yyyy é valida
     * @param c Form Control
     */
    dateValid: (c: FormControl) => {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(c.value) && isValidDate(c.value)) {
            return null;
        } else if (c.value) {
            return { dateValid: true };
        }
    },
    /**
     * Valida se a pessoa é menor de idade de acordo com a data de nascimento informada
     * @param c FormControl
     */
    isUnderAge: (c: FormControl) => {
        if (isValidDate(c.value)) {
            const birthDate = new Date(convertDate(c.value))
            const age = getAge(birthDate)
            if (age < 18) {
                return { underAge: true }
            }

            return null
        }
    },


    /**
     * Valida a data se é menor que a data atual, e maior que a data de nascimento
     * @param c Any
     */
    dateCommonValidate: (c: any) => {
        if (isValidDate(c.value)) {
            const now = new Date().getTime();
            const date = new Date(convertDate(c.value)).getTime();
            const dateBirthday: any = new Date(c.parent.parent.controls.birthdayDate.value).getTime();

            if (now < date) {
                return { invalidDate: true };
            } else if (dateBirthday > date) {
                return { validDateToBirthday: true };
            } else {
                return null;
            }
        } else if (c.value != null && c.value.length > 0) {
            return { invalidDate: true };
        }
    },

    /**
     * Valida se o seletor job foi preenchido
     * @param c Any
     */
    jobRequired(c: FormControl) {
        if (c.value) {
            return null;
        } else {
            return { 'jobRequired': true };
        }
    },

    dateBeforeToday: (c: FormControl) => {
        const date = new Date();
        let auxDate: any[];
        let inputDate: Date;

        // Só entra na condicional quando a mesma se encontrar completa na tela
        if (c && c.value && /^\d{2}\/\d{2}\/\d{4}$/.test(c.value)) {

            auxDate = c.value.split('/');
            inputDate = new Date(parseInt(auxDate[2], 10), parseInt(auxDate[1], 10) - 1, parseInt(auxDate[0], 10));

            // Verifica se a data imputada pelo usuário é menor ou igual a data de hoje
            if (inputDate <= date) {
                return null;
            } else {
                return { 'dateBeforeToday': false };
            }
        }
    },

    checked: (c: FormControl) => {
        if (c.value) {
            return null;
        } else if (!c.value) {
            return { checked: true };
        }
    },

    match(value) {
        return (c: FormControl) => {
            if (c.value) {
                return;
            } else {
                return { minvalue: true };
            }
        };
    },

    validPhone: (c: FormControl) => {
        if (/^\([1-9]{2}\) [7-9] [1-9][0-9]{3}\-[0-9]{4}$/.test(c.value) || c.value == "") {
            return null;
        } else {
            return { phoneError: true };
        }
    },

    passwordMismatch: (c: FormControl, fieldName: string = "password") => {
        var password = "";
        const rePassword = c.value;
        if (c.parent && c.parent.get(fieldName))
            password = c.parent.get(fieldName).value;
        if (password !== rePassword)
            return { passwordMismatch: true }
        return null;
    }
};

/**
 * Validação de valor mínimo composta (soma de vários campos do formulário)
 * @param controlsNamesToSum lista de controles a serem usados na soma
 * @param minValue valor mínimo
 * @param controlNameToSetError controle onde o erro deve ser setado caso a validação não passe
 */

export const compositeMinValue = (controlsNamesToSum: string[], minValue: number, controlNameToSetError: string,
    optionalControls: string[] = []): ValidatorFn => {

    return (form: AbstractControl) => {

        const controlsToCheckout = controlsNamesToSum.map((name) => {
            const control = form.get(name);
            control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
            const controlIsValidOrOptions = control.valid || (!control.valid && optionalControls.find((res) => res === name));
            return controlIsValidOrOptions || control.touched || (control.value !== '' && control.value !== undefined);
        })
            .filter((shouldCheck) => shouldCheck === true);

        if (controlsToCheckout.length === controlsNamesToSum.length) {

            let sum = 0;
            controlsNamesToSum.forEach((name) => {
                const controls = form.get(name);
                if (controls && controls.value != null && controls.value !== undefined) {
                    sum += +(controls.value || 0);
                }
            });

            const control = form.get(controlNameToSetError);
            // Soma dos valores tem que ser maior que 30 e menor que 10 bilhoes
            if (sum < minValue || sum >= 9999999999) {
                control.setErrors({ ...{}, ...control.errors, ...{ compositeMinValuNotReached: true } });
            } else {
                control.updateValueAndValidity({ onlySelf: true });
            }
        }

        return null;
    };
};

/**
 * Valida se um form control possui valor único em um dado FormGroup
 * @param formGroup onde os valores serão checados
 */
export const uniqueInFormGroup = (formGroup: any, errorName: string = 'notUnique'): ValidatorFn => {

    return (control: AbstractControl) => {

        const equalControls: any[] = [];
        let isUnique: boolean = true;
        let controlKey: string;

        if (formGroup.controls.length === 1 || !control.parent) {
            return null;
        }
        for (const c in control.parent.controls) {
            if (control.parent.controls[c] === control) {
                controlKey = c;
            }
        }

        for (const i in formGroup.controls) {
            if (formGroup.controls[i].controls[controlKey] === control) {
                continue;
            }
            if (formGroup.controls[i].controls[controlKey].value === control.value && control.value && control.value.trim() !== '') {
                equalControls.push(formGroup.controls[i].controls[controlKey]);
                isUnique = false;
                break;
            }
        }

        if (equalControls.length > 0) {
            equalControls.forEach((controls) => {
                controls.setErrors({ [errorName]: controls.value });
                controls.markAsDirty(true);
                controls.markAsTouched(true);
            });
        }

        if (isUnique) {
            const controlsWithErrors = [];
            // tslint:disable-next-line
            for (let i in formGroup.controls) {
                for (const f in formGroup.controls[i].controls) {
                    if (formGroup.controls[i].controls[f].errors) {
                        if (formGroup.controls[i].controls[f].errors[errorName]) {
                            controlsWithErrors.push(formGroup.controls[i].controls[f]);
                        }
                    }
                }
            }

            let counterRepeated = {};
            controlsWithErrors.forEach((controlz) => {
                if (counterRepeated.hasOwnProperty(controlz.errors[errorName])) {
                    counterRepeated[controlz.errors[errorName]] += 1;
                } else {
                    counterRepeated[controlz.errors[errorName]] = 1;
                }
            });

            counterRepeated = Object.entries(counterRepeated)
                .filter((item) => item[1] < 2)
                .map((item) => item[0]);
            controlsWithErrors.forEach((controlz) => {
                if ((counterRepeated as any[]).indexOf(controlz.errors[errorName]) > -1) {
                    let newObj = Object.assign(controlz.errors, {});
                    delete newObj[errorName];
                    newObj = Object.keys(newObj).length === 0 ? null : newObj;
                    controlz.setErrors(newObj);
                }
            });

            return null;
        } else {
            return { [errorName]: control.value };
        }
    };
};

export const validateFields = (fieldName: string): ValidatorFn => {
    return (group: FormGroup): { [key: string]: boolean } => {
        return null;
    };
};

/** A hero's name can't match the given regular expression */
export function crazyValidator(formGroup: AbstractControl, fieldName: string): ValidatorFn {
    const formGroupControl = formGroup as FormGroup;
    return (control: AbstractControl): { [key: string]: any } => {

        if (!formGroupControl.controls.length) {
            return null;
        }
        if (v(control, formGroupControl, fieldName)) {
            return { notUnique: true };
        }
        return null;
    };
}

function v(triggerControl: AbstractControl, group: FormGroup, fieldName: string) {
    // tslint:disable-next-line
    for (let field in group.controls) {
        const control = group.controls[field] as FormGroup;

        if (control.controls[fieldName] === triggerControl) {
            continue;
        }
        if (!!triggerControl.value && control.value[fieldName] === triggerControl.value) {
            return true;
        }
    }

    return false;
}

/* * Dispara a validação em um formGroup/lista de controls
 * @param formGroup FormGroup a ser atingido
 */

function triggerValidation(formGroup: FormGroup, triggerControl: AbstractControl) {
    if (formGroup) {
        Object.keys(formGroup.controls)
            .forEach((field) => {
                const control = formGroup.get(field);

                if (control === triggerControl) {
                    return;
                }
                if (control instanceof FormControl) {
                    control.markAsTouched({ onlySelf: true });
                } else if (control instanceof FormGroup) {
                    triggerValidation(control, triggerControl);
                }
            });
    }
}

export function convertDate(date): Date {
    return new Date(`${date.substr(3, 2)}/${date.substr(0, 2)}/${date.substr(6, 4)}`);
}

function VerificaCPF(CPF: any) {

    if (CPF.length < 11) {
        return false;
    }

    const cpf = CPF.replace(/[\D]/ig, '');

    let numeros: any;
    let digitos: any;
    let soma: any;
    soma = 0;
    let i: any;
    let resultado: any;
    let digitosIguais: any = 1;
    digitosIguais = 1;

    if (cpf.length < 11) {
        return false;
    }

    for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
        }
    }

    if (!digitosIguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== +digitos.charAt(0)) {
            return false;
        }
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== +digitos.charAt(1)) {
            return false;
        }
        return true;
    } else {
        return false;
    }
}

export function getAge(birthDate: Date) { return Math.floor((new Date().getTime() - new Date(birthDate).getTime()) / 3.15576e+10) }

export function isValidDate(date: string) {
    if (date == null || date.length == 0) return false;
    const splitDate = date
        .split('/')
        .map((part) => +part);
    const newDate = new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
    return newDate && (newDate.getMonth() + 1) === +splitDate[1] && newDate.getFullYear() > 1920;
}

/**
 * Validador de CNPJ
 * @exemple 29.162.769/0001-98
 *
 * soma primeiro digito = 233
 * calculo primeiro digito: 233 / 11 => resto = 2 => 11-2 = 9
 *
 * soma segundo digito = 278
 * calculo segundo digito: 278 / 11 => resto = 3 => 11-3 = 8
 *
 * digito verificador = 98
 */
function validateCnpj(cnpjMask: string): boolean {

    if (!cnpjMask) return false;

    const cnpj = cnpjMask.replace(/[^\d]/g, '');
    const regex = (/[0]{14}|[1]{14}|[2]{14}|[3]{14}|[4]{14}|[5]{14}|[6]{14}|[7]{14}|[8]{14}|[9]{14}/gm);
    const isCnpjBlocked = regex.test(cnpj);

    if (cnpj.length !== 14 || isCnpjBlocked) return false;

    // pesos
    const weights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    // digito verificador CNJ
    const verifyingDigit = cnpj.substr(-2);

    // calculando primeiro digito verificador
    const digitOne = { sum: 0, remainder: 0, result: 0 };
    digitOne.sum = sumCNPJ(weights, cnpj);
    digitOne.remainder = digitOne.sum % 11;
    digitOne.result = digitOne.remainder < 2 ? 0 : 11 - digitOne.remainder;

    // calculando segundo digito verificador
    const digitTwo = { sum: 0, remainder: 0, result: 0 };
    weights.unshift(6);
    digitTwo.sum = sumCNPJ(weights, cnpj);
    digitTwo.remainder = digitTwo.sum % 11;
    digitTwo.result = digitTwo.remainder < 2 ? 0 : 11 - digitTwo.remainder;

    return `${digitOne.result}${digitTwo.result}` === verifyingDigit;

}

function sumCNPJ(weights: number[], cnpj: string): number {

    let sum = 0;
    weights.forEach((num: number, index) =>
        sum += (+cnpj.charAt(index) * num));

    return sum;

}

/**
 * Valida se dois campos (senha e confirmação de senha) de um formulário possuem o mesmo valor
 * @param passwordFieldName nome do field de senha no formulário
 * @param confirmPasswordFieldName nome do field de confirmação de senha no formulário
 */
export function matchPassword(passwordFieldName: string = 'password', confirmPasswordFieldName: string = 'confirmPassword') {
    return (form: AbstractControl) => {

        const password = form.get(passwordFieldName).value;
        const confirmPassword = form.get(confirmPasswordFieldName).value;

        if (password === confirmPassword) {
            return null;
        }

        form.get(confirmPasswordFieldName)
            .setErrors({ MatchPassword: true });
    };
}

/**
 * Valida se dois campos (email e confirmação de email) de um formulário possuem o mesmo valor
 * @param emailFieldName nome do field de email no formulário
 * @param confirmEmailFieldName nome do field de confirmação de email no formulário
 */
export function matchEmail(emailFieldName: string = 'email', confirmEmailFieldName: string = 'confirmEmail') {
    return (form: AbstractControl) => {

        const email = form.get(emailFieldName).value;
        const confirmEmail = form.get(confirmEmailFieldName).value;

        if (email === confirmEmail) {
            return null;
        }

        form.get(confirmEmailFieldName)
            .setErrors({ MatchEmail: true });
    };
}
